import React from "react";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { useTranslation } from "@helpers/translate";
import "./index.sass";

const ActionButtons = ({ pairSlug }) => {
  const { __ } = useTranslation();
  const navigate = useNavigate();

  const handleTradeClick = () => {
    if (!pairSlug) return;
    navigate(`/?pair=${pairSlug}`);
  };

  const button = (
    <button
      className="markets-table-actions__button"
      type="button"
      onClick={handleTradeClick}
      disabled={!pairSlug}
    >
      {__("wallet.trade")}
    </button>
  );

  return (
    <div className="markets-table-actions">
      {pairSlug ? (
        button
      ) : (
        <Tooltip
          title={__("markets.pair_unavailable")}
          placement="top"
          arrow
          enterTouchDelay={0}
          leaveTouchDelay={1500}
          classes={{
            tooltip: "markets-table-actions__tooltip",
            arrow: "markets-table-actions__tooltip-arrow",
          }}
        >
          <span className="markets-table-actions__tooltip-anchor">{button}</span>
        </Tooltip>
      )}
    </div>
  );
};

export default ActionButtons;
